import { BUSINESS_ADMIN_HOST } from 'api/constants';

export const KYC_CONTACT_URL = `${BUSINESS_ADMIN_HOST}/v1/kyc-contacts`;
